import { ChakraProvider } from '@chakra-ui/react';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';

import { baseThemeDeer } from 'themes/clients/baseThemeDeer';

// Note for anyone re-auditing MS Teams / MUI-styled screens here: this only sets the
// Chakra/Emotion theme. src/screens/MSTeams/* renders under its own always-on
// MuiThemeProvider/styled-components ThemeProvider (see src/index.jsx), which is wired up
// independently of this provider - so this theme alone does not affect their styling.
// Confirmed via code audit; no patches were needed there.
export const ChakraThemeProvider = ({ children }) => (
  <ChakraProvider resetCSS={false} theme={baseThemeDeer}>
    {/* remove emotion theme provider when all usages are replaced with native theme usage from Chakra */}
    <EmotionThemeProvider theme={baseThemeDeer}>{children}</EmotionThemeProvider>
  </ChakraProvider>
);
